import React, { Component } from "react";
import DomesticContext from "./DomesticContext";
import Payment from "../../images/payment.svg";
import Crypter from "../../utils/crypter";
import moment from "moment";
import { RemoveFucntionObject } from "../../utils";
import { DATETHAI_FORMAT } from "../../const";
import { CurrencyUtils } from "../../utils";
const { REACT_APP_URL_2C2P_REDIRECT } = process.env;

const imgScale = {
  width: "24px",
  height: "24px",
};
const Icon = (props) => <img className={props.className} src={props.src} {...imgScale} />;

class DomesticStep5 extends Component {
  callBackAction;
  state = {
    isSubmitted: false,
  };
  constructor(props) {
    super(props);
  }

  render() {
    const { isSubmitted } = this.state;
    const { paymentModel } = this.context.step5;
    const hash1 = Crypter.decode(paymentModel.hash1 || "") || "";
    const hashs = hash1.split(",");
    let ver, mer, cur;
    if (hashs && hashs.length === 3) {
      ver = hashs[0];
      mer = hashs[1];
      cur = hashs[2];
    }

    const { step1, step2 } = this.context;
    const { start_date, end_date, counter, provinceFrom, provinceTo, provinceOther, type } = step1;

    const { selectedPlan, planList } = step2;
    const planDetail = planList.filter((plan) => plan.id === selectedPlan)[0] || {};
    const { insured, total } = planDetail;
    const totalAmount = counter ? total * counter : total;

    const from = provinceFrom ? provinceFrom.label + "-" : "";
    const otherConcat = (provinceOther || []).map((po) => po.label).join("-");
    const to = provinceTo ? "-" + provinceTo.label : "";
    let provinceTravel = from + otherConcat + to
    if (type === 4) {
      const fromNoDash = provinceFrom ? provinceFrom.label : "";
      provinceTravel += `-${fromNoDash}`;
    }
    return (
      <div className="form-wrapper payment-wrapper">
        <div className="form-group d-flex flex-column flex-1 w-100">
          <div className="circle-bg">
            <Icon className="align-item-center w-100 payment-icon" src={Payment} />
          </div>
          <div className="form-group">
            <div className="payment-reactagle">
              <label>ชำระเบี้ยประกัน</label>
              <br />
              <label>การเดินทางในประเทศ</label>
            </div>
          </div>
          <div className="form-wrapper order-wrapper">
            <div className="form-group d-flex flex-column flex-1 w-100">
              <div className="form-group">
                <label>เลขที่ใบสั่งซื้อ</label>
                <label className="order-value">{paymentModel.orderId}</label>
                {/* get refNo */}
              </div>
              <div className="form-group">
                <label>วันที่เดินทาง</label>
                <label className="order-value">
                  {moment(start_date).format(DATETHAI_FORMAT)} - {moment(end_date).format(DATETHAI_FORMAT)}
                </label>
              </div>
              <div className="form-group">
                <label>ประเทศปลายทาง</label>
                <label className="order-value">{from + otherConcat + to}</label>
              </div>
              <div className="form-group">
                <div className="totalPrice-wrapper d-flex flex-column align-item-center justify-content-center">
                  <label>ยอดรวมที่ต้องชำระ</label>
                  <label className="order-value">{CurrencyUtils.currency(totalAmount)} บาท</label>
                </div>
              </div>
            </div>
          </div>
          <div className="form-wrapper text-center">
            <button
              className="btn-primary align-item-center payment-btn"
              onClick={() =>
                this.setState({ isSubmitted: true }, () => {
                  localStorage.setItem("states_dom", this.getStepFromContext());
                  setTimeout(() => {
                    document.getElementById("submitBtn").click();
                  }, 1000);
                })
              }
            >
              ชำระเบี้ยเต็มจำนวน
            </button>
          </div>
        </div>
        {REACT_APP_URL_2C2P_REDIRECT}
        {paymentModel.returnUrl}
        {paymentModel.hashValue}
        {paymentModel.paymentDescription}
        {paymentModel.orderId}
        {paymentModel.paymentAmount}
        {isSubmitted && (
          <form
            id="myform"
            className="d-none"
            method="post"
            action={REACT_APP_URL_2C2P_REDIRECT}
          >
            <input type="hidden" name="version" value={ver} />
            <input type="hidden" name="merchant_id" value={mer} />
            <input type="hidden" name="currency" value={cur} />
            <input type="hidden" name="result_url_1" value={paymentModel.returnUrl} />
            <input type="hidden" name="hash_value" value={paymentModel.hashValue} />
            <input type="hidden" name="payment_description" value={paymentModel.paymentDescription} />
            <br />
            <input type="hidden" name="order_id" value={paymentModel.orderId} />
            <br /> {/* send refNo on order_id field */}
            <input type="hidden" name="amount" value={paymentModel.paymentAmount} />
            <br />
            <input id="submitBtn" type="submit" name="submit" value="Confirm" />
          </form>
        )}
      </div>
    );
  }

  getStepFromContext() {
    let { step1, step2, step3, step4, step5, diffDate } = this.context;
    step1 = RemoveFucntionObject(step1);
    step2 = RemoveFucntionObject(step2);
    step3 = RemoveFucntionObject(step3);
    step4 = RemoveFucntionObject(step4);
    step5 = RemoveFucntionObject(step5);

    const data = JSON.stringify({ step1, step2, step3, step4, step5, diffDate });
    console.log(data);

    return Crypter.encode(data);
  }
}

DomesticStep5.contextType = DomesticContext;
export default DomesticStep5;
